"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NovuRestTriggersEnum = exports.NovuViolationsTriggerEnum = exports.NovuMaintenanceTriggersEnum = exports.SubscriberType = void 0;
var SubscriberType;
(function (SubscriberType) {
    SubscriberType["UserType"] = "user";
    SubscriberType["AccountType"] = "account";
    SubscriberType["GroupType"] = "group";
})(SubscriberType = exports.SubscriberType || (exports.SubscriberType = {}));
var NovuMaintenanceTriggersEnum;
(function (NovuMaintenanceTriggersEnum) {
    NovuMaintenanceTriggersEnum["NewRequest"] = "addrequest";
    NovuMaintenanceTriggersEnum["NewMaintenanceAssigned"] = "new-maintenance-assigned";
    NovuMaintenanceTriggersEnum["MaintenanceUpdate"] = "maintenance-updated";
    NovuMaintenanceTriggersEnum["UpdateRequestUpdate"] = "update-request-update";
    NovuMaintenanceTriggersEnum["NewRequestUpdate"] = "new-request-update";
    NovuMaintenanceTriggersEnum["UpcomingMaintenanceAlerts"] = "upcoming-maintenance-alerts";
    NovuMaintenanceTriggersEnum["MaintenanceChecklistNotifications"] = "maintenance-checklist-notifications";
})(NovuMaintenanceTriggersEnum = exports.NovuMaintenanceTriggersEnum || (exports.NovuMaintenanceTriggersEnum = {}));
var NovuViolationsTriggerEnum;
(function (NovuViolationsTriggerEnum) {
    NovuViolationsTriggerEnum["SendUserNotifications"] = "send-user-notifications";
    NovuViolationsTriggerEnum["SendViolationSummary"] = "send-violation-summary";
    NovuViolationsTriggerEnum["SendOverspeedNotifications"] = "overspeed-notifications";
    NovuViolationsTriggerEnum["SendGeofenceNotifications"] = "geofence-notifications";
    NovuViolationsTriggerEnum["SendFuelNotifications"] = "fuel-theft-alert";
    NovuViolationsTriggerEnum["SendLowFuelNotifications"] = "low-fuel-notifications";
    NovuViolationsTriggerEnum["SendIdlingNotifications"] = "idling-violation-notifications";
    NovuViolationsTriggerEnum["SendHarshDrivingNotifications"] = "harsh-driving-alerts";
    NovuViolationsTriggerEnum["RestrictedGeofenceViolation"] = "restricted-geofence-violations";
})(NovuViolationsTriggerEnum = exports.NovuViolationsTriggerEnum || (exports.NovuViolationsTriggerEnum = {}));
var NovuRestTriggersEnum;
(function (NovuRestTriggersEnum) {
    NovuRestTriggersEnum["OperatorDocumentExpiryAlerts"] = "operator-document-expiry-alerts";
    NovuRestTriggersEnum["InviteExistingUser"] = "invite-existing-user";
    NovuRestTriggersEnum["InviteNewUser"] = "invite-new-user";
    NovuRestTriggersEnum["EquipmentDocumentExpiryAlerts"] = "equipment-document-expiry-alerts";
    NovuRestTriggersEnum["EquipmentOrderCreated"] = "equipment-order-created";
    NovuRestTriggersEnum["EquipmentRequestUpdated"] = "equipment-request-update";
    NovuRestTriggersEnum["EquipmentRequestCreated"] = "equipment-request-created";
    NovuRestTriggersEnum["EquipmentDeallocationWarning"] = "equipment-deallocation-warning";
    NovuRestTriggersEnum["EquipmentDeallocated"] = "equipment-deallocated";
})(NovuRestTriggersEnum = exports.NovuRestTriggersEnum || (exports.NovuRestTriggersEnum = {}));
//# sourceMappingURL=notifications.js.map